import React, { FunctionComponent, useState } from 'react';
import { Typography } from '@material-ui/core';
import GenericAccordion from '../../../../../../../common/components/presentation/genericAccordion/GenericAccordion';
import { ISpecification } from '../../../../../../model/IVariantSpecifications';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import SpecificationsAccordionContent from '../specificationsAccordionContent/SpecificationsAccordionContent';
import specificationsDetailItemStyles from './specificationsDetailItemStyles';

export interface ISpecificationsDetailItemProps {
  category: string;
  specifications: ISpecification[];
}

const SpecificationsDetailItem: FunctionComponent<ISpecificationsDetailItemProps> = ({ category, specifications }) => {
  const styles = specificationsDetailItemStyles();
  const [expanded, setExpanded] = useState(false);

  return (
    <GenericAccordion
      summary={
        <Typography
          color="textSecondary"
          variant="subtitle1"
          className={styles.title}
          data-test="customise:specifications_category_title"
        >
          {category}
        </Typography>
      }
      details={
        <Table>
          <TableBody>
            {specifications.map(specification => (
              <SpecificationsAccordionContent key={specification.key} specification={specification} />
            ))}
          </TableBody>
        </Table>
      }
      expanded={expanded}
      defaultExpanded={false}
      setExpanded={setExpanded}
      classes={{
        accordionSummary: styles.accordionSummary,
      }}
    />
  );
};

export default SpecificationsDetailItem;
